<!--File: cgp-footer.template.js-->
<!--Author: Joseph M Diaz-->
<!--Date: 4/27/2017-->
<!--Desc: CGP Footer that displays Company, AppName, and Version.-->
<!--Other Contributors:-->

<div class="cgp-footer">
    <div class="footer-text">
        <span class="xs-hide"><img alt="GENERAL MOTORS" src="./assets/img/general_motors.png" class="general-motors" width="100%" height="100%" />
            | </span>
        <span>{{appName}}</span>
    </div>
</div>